import {
  SnippetElement,
  defineElement,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-CFQW6ARL.js";

// src/snippets/pb-shop-gift-card-form/pb-shop-gift-card-form.ts
var PbShopGiftCardForm = class extends SnippetElement {
  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.initRecipientForm);
    } else {
      this.initRecipientForm();
    }
  }
  initRecipientForm() {
    this.checkboxes.forEach(function(checkbox) {
      const sectionId = checkbox.id.replace("recipient-checkbox-", "");
      const fields = document.getElementById("recipient-fields-" + sectionId);
      if (!fields)
        return;
      fields.querySelectorAll("input, textarea").forEach(function(f) {
        f.disabled = true;
      });
      checkbox.addEventListener("change", function() {
        if (checkbox.checked) {
          fields.classList.remove("hidden");
          fields.classList.add("flex");
          fields.querySelectorAll("input, textarea").forEach(function(f) {
            f.disabled = false;
          });
        } else {
          fields.classList.remove("flex");
          fields.classList.add("hidden");
          fields.querySelectorAll("input, textarea").forEach(function(f) {
            f.value = "";
            f.disabled = true;
          });
        }
      });
    });
  }
};
__decorateClass([
  queryAll("[data-recipient-checkbox]")
], PbShopGiftCardForm.prototype, "checkboxes", 2);
PbShopGiftCardForm = __decorateClass([
  defineElement("pb-shop-gift-card-form")
], PbShopGiftCardForm);
export {
  PbShopGiftCardForm
};
